<div class="side-nav-container">


  @if (customNavigation().length) {

    @for (level1 of customNavigation(); track level1.id) {
      @if (level1?.shortTitle || level1?.title) {
        <a [routerLink]="getUrl(level1.sourceUrl).url"
           [queryParams]="getUrl(level1.sourceUrl).props">
          <div class="nav-item"
               [class.nav-item-selected]="pageData()?.id === level1?.id">
            <div class="nav-title">
              {{ level1?.shortTitle || level1?.title }}
            </div>
          </div>
        </a>
      }
    }
    @if (pageData().siblings?.length) {
      @for (level1 of pageData().siblings; track level1.id) {
        <a [routerLink]="getUrl(level1.sourceUrl).url"
           [queryParams]="getUrl(level1.sourceUrl).props">
          <div class="nav-item nav-item-level2"
               [class.nav-item-selected]="pageData()?.id === level1?.id">
            <div class="nav-title">
              {{ level1?.shortTitle || level1?.title }}
            </div>
          </div>
        </a>
      }
    }

  } @else {
    @if (pageData().isRoot) {
      @for (level1 of pageData().children; track level1.id) {
        <a [routerLink]="getUrl(level1.sourceUrl).url"
           [queryParams]="getUrl(level1.sourceUrl).props">
          <div class="nav-item"
               [class.nav-item-selected]="pageData()?.id === level1?.id">
            <div class="nav-title">
              {{ level1?.shortTitle || level1?.title }}
            </div>
          </div>
        </a>
      }
    }

    @if (!pageData().isRoot) {
      @if (pageData().breadcrumbs && pageData().breadcrumbs.length <= 1) {
        @for (level1 of pageData().siblings; track level1.id) {
          <a [routerLink]="getUrl(level1.sourceUrl).url"
             [queryParams]="getUrl(level1.sourceUrl).props">
            <div class="nav-item"
                 [class.nav-item-selected]="pageData()?.id === level1?.id">
              <div class="nav-title">
                {{ level1?.shortTitle || level1?.title }}
              </div>
            </div>
          </a>
          @if (level1.id === pageData().id) {
            @for (level2 of pageData().children; track level2.id) {
              <a [routerLink]="getUrl(level2.sourceUrl).url"
                 [queryParams]="getUrl(level2.sourceUrl).props">
                <div class="nav-item nav-item-level2"
                     [class.nav-item-selected]="pageData()?.id === level2?.id">
                  <div class="nav-title">
                    {{ level2?.shortTitle || level2?.title }}
                  </div>
                </div>
              </a>
            }
          }
        }
      }

      @if (pageData().children?.length && pageData().siblings?.length && pageData().breadcrumbs.length > 1) {
        @for (level1 of pageData().siblings; track level1.id) {
          <a [routerLink]="getUrl(level1.sourceUrl).url"
             [queryParams]="getUrl(level1.sourceUrl).props">
            <div class="nav-item"
                 [class.nav-item-selected]="pageData()?.id === level1?.id">
              <div class="nav-title">
                {{ level1?.shortTitle || level1?.title }}
              </div>
            </div>
          </a>
          @if (level1.id === pageData().id) {
            @for (level2 of pageData().children; track level2.id) {
              <a [routerLink]="getUrl(level2.sourceUrl).url"
                 [queryParams]="getUrl(level2.sourceUrl).props">
                <div class="nav-item nav-item-level2"
                     [class.nav-item-selected]="pageData()?.id === level2?.id">
                  <div class="nav-title">
                    {{ level2?.shortTitle || level2?.title }}
                  </div>
                </div>
              </a>
            }
          }
        }
      }

      @if (lastBread() && !pageData().children?.length) {
        <a [routerLink]="getUrl(lastBread().sourceUrl).url"
           [queryParams]="getUrl(lastBread().sourceUrl).props">
          <div class="nav-item"
               [class.nav-item-selected]="pageData()?.id === lastBread().id">
            <div class="nav-title">
              {{ lastBread()?.shortTitle || lastBread().title }}
            </div>
          </div>
        </a>
        @for (level2 of pageData().siblings; track level2.id) {
          <a [routerLink]="getUrl(level2.sourceUrl).url"
             [queryParams]="getUrl(level2.sourceUrl).props">
            <div class="nav-item nav-item-level2"
                 [class.nav-item-selected]="pageData()?.id === level2?.id">
              <div class="nav-title">
                {{ level2?.shortTitle || level2?.title }}
              </div>
            </div>
          </a>
        }
      }
    }
  }
</div>
